export const EXTERNAL_AUTH = 'EXTERNAL_AUTH';
export const EXTERNAL_AUTH_PENDING = 'EXTERNAL_AUTH_PENDING';
export const EXTERNAL_AUTH_FULFILLED = 'EXTERNAL_AUTH_FULFILLED';
export const EXTERNAL_AUTH_REJECTED = 'EXTERNAL_AUTH_REJECTED';
